

































import Vue from 'vue'
import * as R from 'ramda'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import AppSelector from '@/components/AppSelector.vue'
import { IAccountVehicleInput } from '@/modules/AccountAsset/interfaces/account-asset-form'
import { states } from '@/utils/us_states'

import { vehicleOwnerships } from '@/modules/Vehicle/helpers/vehicle-ownership'
import { vehicleUseages } from '@/modules/Vehicle/helpers/vehicle-useage'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppDatePicker
  }
})
export default class AccountAssetFormVehicle extends Vue {
  @Prop({ type: Object as () => IAccountVehicleInput }) value!: IAccountVehicleInput

  recordTypeIndex = -1
  states = states
  vehicleOwnerships = vehicleOwnerships
  vehicleUseages = vehicleUseages
  R = R

  get today () {
    return this.$moment().format('YYYY-MM-DD')
  }

  validate () {
    return true
  }
}
